export { default } from './PanelHeader';
